import { CddEmbeddedFields } from '../../../eddQuestions/pages/direct/field.types';
import { CddVolumesQuestion } from '../../common/CddVolumesQuestion';
import type { CddAchVolumesFormContentKeys } from '../../common/cddVolumesForm.types';

export const CddAchVolumesForm = ({
  contentKeys,
}: {
  contentKeys: CddAchVolumesFormContentKeys;
}) => (
  <div>
    <CddVolumesQuestion
      sectionKey='achVolumes'
      fieldName={CddEmbeddedFields.CDD_ACH_VOLUMES_INCOMING}
      contentKey={contentKeys.achIncomingQuestion}
    />
    <CddVolumesQuestion
      sectionKey='achVolumes'
      fieldName={CddEmbeddedFields.CDD_ACH_VOLUMES_OUTGOING}
      contentKey={contentKeys.achOutgoingQuestion}
    />
  </div>
);
